module.exports = __webpack_public_path__ + "img/Saint_valentin.22f6271.jpg";